import { render, staticRenderFns } from "./ProductTestImporter.vue?vue&type=template&id=47302770"
import script from "./ProductTestImporter.vue?vue&type=script&lang=js"
export * from "./ProductTestImporter.vue?vue&type=script&lang=js"
import style0 from "./ProductTestImporter.vue?vue&type=style&index=0&id=47302770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports